export enum ImageType {
  Logo = 1,
  Icon=2,
}
